import xlsx from 'xlsx'

function readFileAsUint8Array(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(new Uint8Array(reader.result))
    reader.onerror = () => reject(reader.error || new Error('讀取 Excel 失敗'))
    reader.readAsArrayBuffer(file)
  })
}

export async function parseExcelUploadFile(file) {
  if (!file) {
    throw new Error('找不到暫存的上傳檔案')
  }
  const data = await readFileAsUint8Array(file)
  const workbook = xlsx.read(data, { type: 'array' })
  const sheetName = workbook.SheetNames[0]
  const sheet = workbook.Sheets[sheetName]
  if (!sheet) {
    throw new Error('Excel 沒有工作表')
  }
  return Object.freeze(xlsx.utils.sheet_to_json(sheet))
}
